// extracted by mini-css-extract-plugin
module.exports = {"item":"dropdown-service_item__3cC_W","link":"dropdown-service_link__1lEyN","icon":"dropdown-service_icon__3nYhN"};